// Module
var code = `<template> <div class="icon-picker row align-items-middle justify-content-center" click.delegate="openIconPickerDialog()"> <i class="icon-picker-icon material-icons">\${icon ? icon: '3d_rotation '}</i> <span class="icon-picker-text">Pick icon</span> </div> </template>`;
// Exports
module.exports = code;